<template>
  <div class="card card-light d-flex flex-column">
    <div class="page-subtitle text-white">{{ $t('payment.summary.recap.transaction') }}</div>
    <div class="total-lines content mt-4">
      {{ $t('payment.summary.total.annonces') }}
      <span>{{ totalAnnonces }}</span>
    </div>
    <div class="total-lines content">
      {{ $t('payment.summary.licensed.annonces') }}
      <span>{{ totalLicensed }}€</span>
    </div>
    <div class="total-lines content">
      {{ $t('payment.summary.unlicensed.annonces') }}
      <span>{{ totalUnlicensed }}€</span>
    </div>
    <div class="total-lines content">
      {{ $t('payment.summary.additional.reward') }}
      <span>{{ totalAdditionalReward }}€</span>
    </div>
    <div class="total-lines total mt-3">
      {{ $t('payment.summary.total') }}
      <span>{{ total }}€</span>
    </div>
  </div>
</template>

<script>
import AnnonceCreationUtils from "../../utils/AnnonceCreationUtils";

export default {
  name: "PaymentSummaryTotalCard",
  props: {
    annonces: {
      default: null,
      type: Array,
      required: true
    },
  },

  emits: ['setTotalToPay'],

  data() {
    return {
      totalAnnonces: 0,
      totalLicensed: 0,
      totalUnlicensed: 0,
      totalAdditionalReward: 0,
      total: 0,
    }
  },

  mounted() {
    this.calculateTotals();
  },

  methods: {
    calculateTotals() {
      this.totalAnnonces = this.annonces.length;
      this.totalLicensed = 0;
      this.totalUnlicensed = 0;
      this.totalAdditionalReward = 0;

      this.annonces.forEach((annonce) => {
        if (annonce.isLicensed) {
          this.totalLicensed += AnnonceCreationUtils.licensedAnnoncePrice();
        } else {
          this.totalUnlicensed += AnnonceCreationUtils.unlicensedAnnoncePrice();
        }
        const rewardAmount = annonce.additionnalRewardAmount.value != null ? annonce.additionnalRewardAmount.value : 0;
        this.totalAdditionalReward += rewardAmount;
      });

      this.total = this.totalLicensed + this.totalUnlicensed + this.totalAdditionalReward;

      this.$emit('setTotalToPay', this.total);
    }
  }

}
</script>

<style scoped>

.card-light {
  background-color: var(--main-black-medium);
  padding: 14px 10px;
}

.page-subtitle {
  font-size: 22px;
}

.total-lines {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}

.total {
  font-size: 18px;
}

</style>




// WEBPACK FOOTER //
// src/components/annonce/PaymentSummaryTotalCard.vue